// extracted by mini-css-extract-plugin
export default {"NexusProject":"NexusProject_NexusProject__4-XbM"};